import { interventionReport } from "./intervention-report";

export const reportDefinitions = [
  interventionReport
];
